/**
 * Configuracao central de idiomas suportados pela aplicacao.
 *
 * Este e o unico ponto que precisa ser alterado para adicionar novos idiomas
 * (ex.: 'es', 'fr'): basta incluir o codigo em SUPPORTED_LANGUAGES e criar o
 * arquivo de traducao correspondente em ./locales.
 */
/** Idiomas suportados. `en` deve permanecer como primeiro item (padrao/fallback). */
export var SUPPORTED_LANGUAGES = ['en', 'pt-BR'];
/** Idioma padrao e de fallback da aplicacao. */
export var DEFAULT_LANGUAGE = 'en';
/**
 * Mapeia um idioma suportado para o locale BCP-47 usado pelas APIs de
 * formatacao (Intl.DateTimeFormat / Intl.NumberFormat).
 */
export var LOCALE_BY_LANGUAGE = {
    en: 'en-US',
    'pt-BR': 'pt-BR',
};
/** Type guard: verifica se um valor arbitrario e um idioma suportado. */
export function isSupportedLanguage(value) {
    // Usa indexOf (em vez de Array.prototype.includes) por compatibilidade com o
    // target ES5 configurado no tsconfig.
    return SUPPORTED_LANGUAGES.indexOf(value) !== -1;
}
